import { defaultDiscount } from "./discountHelper";

export const defaultRule = {
    company_category: '',
    visibility: true,
    cost_price_upcharge_percentage: 0,
    discount: defaultDiscount
}